export default function removeFirstWord(str) {
  const indexOfUndefined = str?.indexOf("undefined");

  if (indexOfUndefined === -1 || !indexOfUndefined) {
    return str;
  }

  return str?.substring(indexOfUndefined + 9);
}
